import styled from 'styled-components';
import {space, variant, typography, color, VariantArgs, SpaceProps, ColorProps, TypographyProps} from 'styled-system'
import theme from '../../config/theme';

interface IColorSwitch {
  [key:string]: string,
}

interface IHeader extends SpaceProps{
  weight?: number,
  fontSize?: string,
  color?: string,
}

interface IParagraph extends SpaceProps{
  weight?: number,
  style?: string,
  size?: string,
  color?: string,
  align?: string,
}

interface TextVariantProps{
  variant?: 'muted',
  size?: 'small' | 'big'
}

interface IText extends VariantArgs, SpaceProps, ColorProps, TypographyProps, TextVariantProps{

}

interface ITextSize {
  [key:string]: any,
}

const textSize:ITextSize = {
  xl: {
    'font-size': '28px',
    'line-height': '160%',
  },
  lg: {
    'font-size': '20px',
    'line-height': '160%',
  },
  md: {
    'font-size': '18px',
    'line-height': '168%',
  },
  sm: {
    'font-size': '16px',
    'line-height': '180%',
  },
  xs: {
    'font-size': '14px',
    'line-height': '180%',
  }
}

export const TextColor = '#292929';

export const colorSwitch:IColorSwitch = {
  inherit: 'inherit',
  base: TextColor,
  primary: '#1C62EF',
  ...theme.colors,
}

export const H1 = styled.h1<IHeader>`
  ${space};
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: ${props => props.weight || 600};
  font-size: ${props => props.fontSize || '34px'};
  line-height: 50px;
  text-align: center;
  color: ${props => colorSwitch[props.color || 'base']};
  @media screen and (min-width: 576px) {
    font-weight: ${props => props.weight || 800};
    font-size: ${props => props.fontSize || '36px'};
  }
`

export const H2 = styled.h2<IHeader>`
  ${space};
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: ${props => props.fontSize || '24px'};
  line-height: 150%;
  color: ${props => colorSwitch[props.color || 'base']};
  @media screen and (min-width: 576px) {
    font-weight: 600;
    font-size: ${props => props.fontSize || '24px'};
  }
`

export const H3 = styled.h3<IHeader>`
  ${space};
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: ${props => props.fontSize || '24px'};
  line-height: 150%;
  color: ${props => colorSwitch[props.color || 'base']};
`

export const H4 = styled.h4<IHeader>`
  ${space};
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: ${props => props.fontSize || '18px'};
  line-height: 140%;
  color: ${props => colorSwitch[props.color || 'base']};
  @media screen and (min-width: 576px) {
    font-size: ${props => props.fontSize || '16px'};
    line-height: 150%;
  }
`

export const H5 = styled.h5<IHeader>`
  ${space};
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: ${props => props.fontSize || '16px'};
  line-height: 150%;
  color: ${props => colorSwitch[props.color || 'base']};
  @media screen and (min-width: 576px) {
    font-size: ${props => props.fontSize || '14px'};
    font-weight: 500;
  }
`

export const Paragraph = styled.p<IParagraph>`
  ${space};
  font-family: OpenSans, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: ${props => props.weight || 400};
  line-height: 160%;
  color: ${props => colorSwitch[props.color || 'inherit']};
  ${props => {
    if (props.size && textSize[props.size]) {
      return textSize[props.size]
    }
    return `
      font-size: 18px;
      line-height: 168%;
    `
  }
  }
  text-align: ${props => props.align || 'inherit'}
`

export const Text = styled.p<IText>`
  ${space};
  font-family: OpenSans, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  font-size: 16px;
  ${typography};
  ${color};
  ${variant({
    variants: {
      muted: {
        color: '#4f4f4f',
      },
    }
  })};
  ${variant({
    prop: 'size',
    variants: {
      big: {
        
      },
      small: {
        'font-size': '12px',
      }
    }
  })}
`

export const Span = styled.span<IText>`
  ${space};
  font-family: OpenSans, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  font-size: 16px;
  ${typography};
  ${color};
`

export const ResultSubject = styled.h3<IText>`
  ${typography};
  ${color};
  ${space};
  font-weight: 600;
  font-size: 16px;
  line-height: 180%;
  color: #2C2B48;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: .25rem;
  & > div{
    display: inline-block;
  } 
`

export const HelperText = styled(Paragraph)`
  font-size: 12px;
  line-height: 14px;
`